import { Link } from "react-router-dom";
import { Users, Lock } from "lucide-react";
import { LiveBadge, VerifiedBadge, InstitutionMark } from "@/components/Brand";
import { CATEGORIES, formatCount } from "@/lib/api";

export function LiveCard({ room, count, index = 0 }) {
  return (
    <Link to={`/sala/${room.id}`} data-testid={`live-card-${room.id}`} style={{ animationDelay: `${index * 60}ms` }}
      className="rise group relative block aspect-[3/4] overflow-hidden rounded-2xl bg-card ring-1 ring-white/5 transition-transform duration-300 hover:-translate-y-1">
      <img src={room.cover_url} alt={room.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-black/30" />
      <div className="absolute left-2.5 right-2.5 top-2.5 flex items-start justify-between gap-2">
        <LiveBadge />
        <span className="inline-flex items-center gap-1 rounded-full bg-black/55 px-2 py-1 text-[11px] font-bold backdrop-blur font-mono-k" data-testid={`live-card-viewers-${room.id}`}>
          <Users size={12} /> {formatCount(count ?? room.viewer_count)}
        </span>
      </div>
      <div className="absolute inset-x-0 bottom-0 p-3">
        <div className="mb-1.5 flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-wider text-white/70">
          {CATEGORIES[room.category]}
          {room.access_type === "approval" && <span className="inline-flex items-center gap-0.5 text-[hsl(var(--gold))]"><Lock size={10} /> Aprovação</span>}
        </div>
        <h3 className="line-clamp-2 text-sm sm:text-base font-bold leading-snug" data-testid="live-card-title">{room.title}</h3>
        <div className="mt-2.5 flex items-center gap-2 rounded-xl bg-white/10 p-1.5 pr-2.5 backdrop-blur-md">
          <InstitutionMark name={room.institution_name} logo={room.institution_logo} color={room.institution_color} size={26} />
          <span className="truncate text-xs font-bold" data-testid="live-card-institution">{room.institution_name}</span>
          <VerifiedBadge className="ml-auto" />
        </div>
      </div>
    </Link>
  );
}
